'use client';

import {
  datadogLogs,
  Site,
} from '@datadog/browser-logs';
import {
  appVersion,
  datadogClientToken,
  environment,
  isDatadogEnabled,
} from '@/env';

let ddInitialized = false;

export const enabledLogs = isDatadogEnabled && ['qa', 'prod'].includes((environment ?? '').toLowerCase());
// Initialize Datadog Browser Logs once per client session
export function initDatadogLogs() {
  try {
    if (!ddInitialized && enabledLogs) {
      datadogLogs.init({
        clientToken: datadogClientToken,
        site: ('us3.datadoghq.com') as Site,
        service: 'surgicalchecklistapp',
        forwardConsoleLogs: ['error', 'warn'],
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
        env: environment,
        version: appVersion,
        beforeSend: (log) => {
          const msg = log?.message as string | undefined;
          const httpUrl = log?.http?.url as string | undefined;
          const isNextStackFrames = (value?: string) => !!value && /\/__nextjs_original-stack-frames(?:$|\?)/.test(value);
          // Drop Next.js dev overlay stack-frame fetch errors regardless of domain
          return (isNextStackFrames(httpUrl) || (msg && isNextStackFrames(msg))) ? false : true;
        },
      });
      ddInitialized = true;
    }
    // for debugging Application Version
    console.log('Application Version: ', appVersion);
  } catch {
    // No-op: do not block app if Datadog init fails
  }
}

// Eager init on import in client
initDatadogLogs();
